module.exports = __webpack_public_path__ + "img/irrigation-control-3.8c49f168.webp";